import React from 'react';
import { Info } from 'lucide-react';
import { formatLeaveDays, pluralizeDays } from '../../utils/numberUtils';

/**
 * One-line Home Leave split note. The chips already show the numbers; this
 * only answers "what's paid?" The AL→HL split is the trip breakdown, not a
 * forecast — do not label it Estimate.
 *
 * audience: 'admin' (RO/HR) | 'employee' (worker self-service)
 */
const HomeLeaveConsumptionNote = ({
  alDays = 0,
  hlDays = 0,
  audience = 'employee',
}) => {
  const al = parseFloat(alDays) || 0;
  const hl = parseFloat(hlDays) || 0;
  if (al <= 0 && hl <= 0) return null;

  const isEmployee = audience === 'employee';

  return (
    <div className="flex items-start gap-2 text-xs text-blue-700 bg-blue-50 rounded-lg px-3 py-2 ring-1 ring-inset ring-blue-600/20">
      <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" aria-hidden="true" />
      <span>
        {al > 0 && (
          <>
            <span className="font-semibold">
              {formatLeaveDays(al)} {pluralizeDays(al)}
            </span>
            {isEmployee ? ' from your Annual Leave (paid), then ' : ' paid Annual Leave, then '}
          </>
        )}
        {hl > 0 && (
          <>
            <span className="font-semibold">
              {formatLeaveDays(hl)} {pluralizeDays(hl)}
            </span>
            {' '}Home Leave
          </>
        )}
      </span>
    </div>
  );
};

export default HomeLeaveConsumptionNote;
